import { createFileRoute } from '@tanstack/react-router';
import { AgencyCampaignsPage } from '../features/agency/AgencyCampaignsPage/AgencyCampaignsPage';
import { AgencyCampaignSection } from '../features/agency/model';
import { brandsRouteSearchSchema } from '../features/campaigns/brands/brandsRouteSearch';
export const Route = createFileRoute('/a/$agencyId_/campaigns/overview')({
  validateSearch: brandsRouteSearchSchema,
  component: DetailsRoute,
});
function DetailsRoute() {
  return <AgencyCampaignsPage section={AgencyCampaignSection.Brands} agencyOverview />;
}
